/* eslint-disable object-curly-spacing */
/* eslint-disable prefer-const */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filter } from 'lodash/fp';

import { fetchAdministrativeDivisions } from 'store/administrative-divisions/administrative-divisions-actions';
import { fetchEnrollmentReportingStats } from 'store/enrollment-reporting-stats/enrollment-reporting-stats-actions';
import { fetchEnrollmentReportingDetail as fetchEnrollmentReportingDetailAction } from 'store/reporting/reporting-actions';
import { administrativeDivisionsByIdSelector, viewableAdminDivisionIdsSelector } from 'store/administrative-divisions/administrative-divisions-selectors';
import EnrollmentReportingStatsDisplay from 'containers/enrollment/components/enrollment-reporting-stats-display';
import EnrollmentReportingStatsFilters from 'containers/enrollment/components/enrollment-reporting-stats-filters';
import { userSelector } from 'store/auth/auth-selectors';

import { LayoutWithHeader } from 'components/layouts';
import Divider from 'components/dividers/divider';
import _ from 'lodash';

let administrativeDivisionsLoaded = false;

class EnrollmentReportingStatsContainer extends Component {
  static mapDispatchToProps = dispatch => ({
    loadAdministrativeDivisions() {
      dispatch(fetchAdministrativeDivisions());
    },
    loadEnrollmentStats: filters => dispatch(fetchEnrollmentReportingStats(filters)),
    fetchEnrollmentReportingDetail: filters => dispatch(fetchEnrollmentReportingDetailAction(filters)),
  })

  static mapStateToProps = (state) => {
    const viewableAdminDivisionIds = viewableAdminDivisionIdsSelector(state);
    const filteredAdministrativeDivisions = filter(
      ad => viewableAdminDivisionIds.includes(ad.id),
    )(administrativeDivisionsByIdSelector(state));

    return {
      administrativeDivisions: filteredAdministrativeDivisions,
      administrativeDivisionsError: state.enrollmentReportingStats.administrativeDivisionsError,
      enrollmentReportingStatsResult: state.enrollmentReportingStats.enrollmentReportingStatsResult,
      isLoadingAdministrativeDivisions: state.administrativeDivisions.isLoadingAdministrativeDivisions,
      isLoadingEnrollmentStats: state.enrollmentReportingStats.isLoadingEnrollmentReportingStats,
      user: userSelector(state),
    };
  }

  constructor(props) {
    super(props);
    administrativeDivisionsLoaded = false;

    this.state = {
      filters: {
        startDate: undefined,
        endDate: undefined,
        administrativeDivisionId: undefined,
        paying: undefined,
        renewal: undefined,
        gender: undefined,
      },
    };
  }

  componentDidMount() {
    const { loadAdministrativeDivisions } = this.props;
    administrativeDivisionsLoaded = false;
    loadAdministrativeDivisions();
  }

  handleExport = () => {
    const { filters } = this.state;
    const { fetchEnrollmentReportingDetail } = this.props;
    fetchEnrollmentReportingDetail(filters);
  }

  updateFilters = (filters) => {
    const { loadEnrollmentStats } = this.props;
    this.setState({ filters }, () => {
      loadEnrollmentStats(filters);
    });
  }

  render() {
    const {
      administrativeDivisions,
      enrollmentReportingStatsResult,
      isLoadingAdministrativeDivisions,
      isLoadingEnrollmentStats,
    } = this.props;

    if (administrativeDivisions.length > 0 && !administrativeDivisionsLoaded) {
      administrativeDivisionsLoaded = true;
      const authUser = JSON.parse(localStorage.getItem('authUser'));
      if (authUser.role === 'enrollment_worker' || authUser.role === 'enrollment_manager') {
        const selectedadministrativeDivision = _.find(administrativeDivisions, { id: authUser.administrativeDivisionId });
        if (selectedadministrativeDivision) {
          let { filters } = this.state;
          filters.administrativeDivisionId = authUser.administrativeDivisionId;
          this.setState({ filters });
        }
      }
      const { filters } = this.state;
      const { loadEnrollmentStats } = this.props;
      loadEnrollmentStats(filters);
    }
    const { filters } = this.state;
    const steps = [{ title: 'Enrollment', href: '/enrollment-reporting' }];

    return (
      <LayoutWithHeader pageTitle="Enrollment" steps={steps}>
        <EnrollmentReportingStatsFilters
          administrativeDivisions={administrativeDivisions}
          filters={filters}
          handleExport={this.handleExport}
          isLoading={isLoadingAdministrativeDivisions}
          updateFilters={this.updateFilters}
        />
        <Divider />
        <EnrollmentReportingStatsDisplay
          isLoading={isLoadingEnrollmentStats}
          {...enrollmentReportingStatsResult}
        />
      </LayoutWithHeader>
    );
  }
}

export default connect(
  EnrollmentReportingStatsContainer.mapStateToProps,
  EnrollmentReportingStatsContainer.mapDispatchToProps,
)(EnrollmentReportingStatsContainer);

EnrollmentReportingStatsContainer.propTypes = {
  administrativeDivisions: PropTypes.arrayOf(PropTypes.shape({})),
  enrollmentReportingStatsResult: PropTypes.shape({}),
  filters: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    administrativeDivisionId: PropTypes.number,
    paying: PropTypes.string,
    renewal: PropTypes.string,
    gender: PropTypes.string,
  }),
  isLoadingAdministrativeDivisions: PropTypes.bool,
  isLoadingEnrollmentStats: PropTypes.bool,
  loadAdministrativeDivisions: PropTypes.func.isRequired,
  loadEnrollmentStats: PropTypes.func.isRequired,
  fetchEnrollmentReportingDetail: PropTypes.func.isRequired,
  user: PropTypes.shape({}),
};

EnrollmentReportingStatsContainer.defaultProps = {
  administrativeDivisions: [],
  enrollmentReportingStatsResult: {},
  filters: {},
  isLoadingAdministrativeDivisions: true,
  isLoadingEnrollmentStats: true,
  user: {},
};
